import styled from "styled-components";

const RecommendMerchantWrapper = styled.div`
  margin-top: 40px;
  padding: 0 16px;

  .recommend-merchant-content {
    width: 100%;
    margin-top: 8px;
    overflow-x: auto;

    ::-webkit-scrollbar {
      display: none;
    }

    .container {
      display: flex;
      flex-direction: row;
      align-items: center;
      overflow-x: scroll;
      height: 100%;
      gap: 8px;
      -ms-overflow-style: none;
      scrollbar-width: none;
      padding-bottom: 24px;
      &::-webkit-scrollbar {
        display: none;
      }
    }

    .contents {
      box-sizing: border-box;
      cursor: pointer;
      flex: 0 0 auto;
      width: 128px;
      margin-right: 8px;
      border-radius: 8px !important;
      border: 1px solid #f1f3f5;
      overflow: hidden;
      box-shadow: 3px 3px 20px rgba(34, 37, 41, 0.05);

      img {
        width: 100%;
        height: 72px;
        background-color: gray;
        object-fit: cover;
        display: block;
      }

      .name-section {
        padding: 8px;
        box-sizing: border-box;

        p:first-child {
          font-size: 0.75rem;
          color: #4a5056;
          font-weight: 400;
        }
        p:last-child {
          font-size: 0.875rem;
          color: #222529;
          font-weight: 500;
        }
      }
    }
  }
`;

export { RecommendMerchantWrapper };
